var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('box',[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"content text-center h2 font-weight-bold"},[_vm._v("\n        Usuários ficam no novo front-end! Abrirá em nova aba...\n      ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }